var map = {
	"./RefundCashlessReport/presentation/locales/en-US.json": 89167,
	"./RefundCashlessReport/presentation/locales/es-ES.json": 66163,
	"./RefundCashlessReport/presentation/locales/pt-BR.json": 85908,
	"./RefundCashlessReport/presentation/locales/pt-PT.json": 11206,
	"./SaleForDayPage/presentation/locales/en-US.json": 55583,
	"./SaleForDayPage/presentation/locales/es-ES.json": 14495,
	"./SaleForDayPage/presentation/locales/pt-BR.json": 91769,
	"./SaleForDayPage/presentation/locales/pt-PT.json": 7965,
	"./Terminal/presentation/locales/en-US.json": 10169,
	"./Terminal/presentation/locales/es-ES.json": 52071,
	"./Terminal/presentation/locales/pt-BR.json": 92968,
	"./Terminal/presentation/locales/pt-PT.json": 91824,
	"./addStore/presentation/locales/en-US.json": 58100,
	"./addStore/presentation/locales/es-ES.json": 42441,
	"./addStore/presentation/locales/pt-BR.json": 44584,
	"./addStore/presentation/locales/pt-PT.json": 75430,
	"./aiBot/presentation/locales/en-US.json": 57160,
	"./aiBot/presentation/locales/es-ES.json": 81327,
	"./aiBot/presentation/locales/pt-BR.json": 577,
	"./aiBot/presentation/locales/pt-PT.json": 72093,
	"./bankAccounts/presentation/locales/en-US.json": 69962,
	"./bankAccounts/presentation/locales/es-ES.json": 85462,
	"./bankAccounts/presentation/locales/pt-BR.json": 29207,
	"./bankAccounts/presentation/locales/pt-PT.json": 88916,
	"./cardBalanceReportApi/presentation/locales/en-US.json": 40864,
	"./cardBalanceReportApi/presentation/locales/es-ES.json": 57032,
	"./cardBalanceReportApi/presentation/locales/pt-BR.json": 82552,
	"./cardBalanceReportApi/presentation/locales/pt-PT.json": 32450,
	"./cardGroups/presentation/locales/en-US.json": 81135,
	"./cardGroups/presentation/locales/es-ES.json": 90585,
	"./cardGroups/presentation/locales/pt-BR.json": 77169,
	"./cardGroups/presentation/locales/pt-PT.json": 95638,
	"./cargos/presentation/locales/en-US.json": 9712,
	"./cargos/presentation/locales/es-ES.json": 81275,
	"./cargos/presentation/locales/pt-BR.json": 87025,
	"./cargos/presentation/locales/pt-PT.json": 33024,
	"./cashCancellation/presentation/locales/en-US.json": 31971,
	"./cashCancellation/presentation/locales/es-ES.json": 72008,
	"./cashCancellation/presentation/locales/pt-BR.json": 32388,
	"./cashCancellation/presentation/locales/pt-PT.json": 58556,
	"./cashClosing/presentation/locales/en-US.json": 54549,
	"./cashClosing/presentation/locales/es-ES.json": 85862,
	"./cashClosing/presentation/locales/pt-BR.json": 24744,
	"./cashClosing/presentation/locales/pt-PT.json": 24548,
	"./cashWithdrawal/presentation/locales/en-US.json": 43102,
	"./cashWithdrawal/presentation/locales/es-ES.json": 10194,
	"./cashWithdrawal/presentation/locales/pt-BR.json": 25744,
	"./cashWithdrawal/presentation/locales/pt-PT.json": 97019,
	"./cashWithdrawalAndSupply/presentation/locales/en-US.json": 38320,
	"./cashWithdrawalAndSupply/presentation/locales/es-ES.json": 2475,
	"./cashWithdrawalAndSupply/presentation/locales/pt-BR.json": 1622,
	"./cashWithdrawalAndSupply/presentation/locales/pt-PT.json": 85786,
	"./catalog/presentation/locales/en-US.json": 57793,
	"./catalog/presentation/locales/es-ES.json": 80416,
	"./catalog/presentation/locales/pt-BR.json": 76656,
	"./catalog/presentation/locales/pt-PT.json": 37689,
	"./classification/presentation/locales/en-US.json": 71509,
	"./classification/presentation/locales/es-ES.json": 85240,
	"./classification/presentation/locales/pt-BR.json": 86047,
	"./classification/presentation/locales/pt-PT.json": 91881,
	"./colaboradores/presentation/locales/en-US.json": 34336,
	"./colaboradores/presentation/locales/es-ES.json": 81921,
	"./colaboradores/presentation/locales/pt-BR.json": 56973,
	"./colaboradores/presentation/locales/pt-PT.json": 35790,
	"./commandMap/presentation/locales/en-US.json": 91128,
	"./commandMap/presentation/locales/es-ES.json": 22801,
	"./commandMap/presentation/locales/pt-BR.json": 24445,
	"./commandMap/presentation/locales/pt-PT.json": 65220,
	"./config/deviceConfig/presentation/locales/en-US.json": 88594,
	"./config/deviceConfig/presentation/locales/es-ES.json": 97065,
	"./config/deviceConfig/presentation/locales/pt-BR.json": 80985,
	"./config/deviceConfig/presentation/locales/pt-PT.json": 6303,
	"./config/integrationsConfig/presentation/locales/en-US.json": 23736,
	"./config/integrationsConfig/presentation/locales/es-ES.json": 93483,
	"./config/integrationsConfig/presentation/locales/pt-BR.json": 26868,
	"./config/integrationsConfig/presentation/locales/pt-PT.json": 66523,
	"./config/smartPrinterConfig/presentation/locales/en-US.json": 22570,
	"./config/smartPrinterConfig/presentation/locales/es-ES.json": 78335,
	"./config/smartPrinterConfig/presentation/locales/pt-BR.json": 93574,
	"./config/smartPrinterConfig/presentation/locales/pt-PT.json": 95063,
	"./contaDigital/presentation/locales/en-US.json": 40173,
	"./contaDigital/presentation/locales/es-ES.json": 93454,
	"./contaDigital/presentation/locales/pt-BR.json": 58248,
	"./contaDigital/presentation/locales/pt-PT.json": 80848,
	"./createOrders/presentation/locales/en-US.json": 45419,
	"./createOrders/presentation/locales/es-ES.json": 91612,
	"./createOrders/presentation/locales/pt-BR.json": 24056,
	"./createOrders/presentation/locales/pt-PT.json": 57901,
	"./crm/presentation/locales/en-US.json": 68907,
	"./crm/presentation/locales/es-ES.json": 47888,
	"./crm/presentation/locales/pt-BR.json": 47140,
	"./crm/presentation/locales/pt-PT.json": 2679,
	"./customerCategories/presentation/locales/en-US.json": 88829,
	"./customerCategories/presentation/locales/es-ES.json": 47653,
	"./customerCategories/presentation/locales/pt-BR.json": 35742,
	"./customerCategories/presentation/locales/pt-PT.json": 43918,
	"./customerInformation/presentation/locales/en-US.json": 79260,
	"./customerInformation/presentation/locales/es-ES.json": 32045,
	"./customerInformation/presentation/locales/pt-BR.json": 77741,
	"./customerInformation/presentation/locales/pt-PT.json": 7393,
	"./customerRegistration/presentation/locales/en-US.json": 25343,
	"./customerRegistration/presentation/locales/es-ES.json": 37697,
	"./customerRegistration/presentation/locales/pt-BR.json": 88657,
	"./customerRegistration/presentation/locales/pt-PT.json": 78367,
	"./customersDashboard/presentation/locales/en-US.json": 77074,
	"./customersDashboard/presentation/locales/es-ES.json": 99953,
	"./customersDashboard/presentation/locales/pt-BR.json": 43271,
	"./customersDashboard/presentation/locales/pt-PT.json": 58103,
	"./detailedSale/presentation/locales/en-US.json": 73576,
	"./detailedSale/presentation/locales/es-ES.json": 2499,
	"./detailedSale/presentation/locales/pt-BR.json": 49643,
	"./detailedSale/presentation/locales/pt-PT.json": 20960,
	"./digitalMenu/presentation/locales/en-US.json": 70459,
	"./digitalMenu/presentation/locales/es-ES.json": 80120,
	"./digitalMenu/presentation/locales/pt-BR.json": 2147,
	"./digitalMenu/presentation/locales/pt-PT.json": 32351,
	"./equipamento/presentation/locales/en-US.json": 81001,
	"./equipamento/presentation/locales/es-ES.json": 8150,
	"./equipamento/presentation/locales/pt-BR.json": 40025,
	"./equipamento/presentation/locales/pt-PT.json": 16954,
	"./events/presentation/locales/en-US.json": 98160,
	"./events/presentation/locales/es-ES.json": 40718,
	"./events/presentation/locales/pt-BR.json": 77177,
	"./events/presentation/locales/pt-PT.json": 31865,
	"./financeiro/presentation/locales/en-US.json": 6166,
	"./financeiro/presentation/locales/es-ES.json": 15006,
	"./financeiro/presentation/locales/pt-BR.json": 79364,
	"./financeiro/presentation/locales/pt-PT.json": 14758,
	"./financialCashWithdrawal/presentation/locales/en-US.json": 7700,
	"./financialCashWithdrawal/presentation/locales/es-ES.json": 23672,
	"./financialCashWithdrawal/presentation/locales/pt-BR.json": 46717,
	"./financialCashWithdrawal/presentation/locales/pt-PT.json": 35954,
	"./financialManagementRecord/presentation/locales/en-US.json": 14683,
	"./financialManagementRecord/presentation/locales/es-ES.json": 46603,
	"./financialManagementRecord/presentation/locales/pt-BR.json": 70707,
	"./financialManagementRecord/presentation/locales/pt-PT.json": 5077,
	"./generalDashboard/presentation/locales/en-US.json": 5494,
	"./generalDashboard/presentation/locales/es-ES.json": 67510,
	"./generalDashboard/presentation/locales/pt-BR.json": 75990,
	"./generalDashboard/presentation/locales/pt-PT.json": 37671,
	"./gestaoVendas/presentation/locales/en-US.json": 84405,
	"./gestaoVendas/presentation/locales/es-ES.json": 94520,
	"./gestaoVendas/presentation/locales/pt-BR.json": 30554,
	"./gestaoVendas/presentation/locales/pt-PT.json": 7043,
	"./groupedSplit/presentation/locales/en-US.json": 75030,
	"./groupedSplit/presentation/locales/es-ES.json": 90393,
	"./groupedSplit/presentation/locales/pt-BR.json": 70388,
	"./groupedSplit/presentation/locales/pt-PT.json": 40722,
	"./houseFlow/presentation/locales/en-US.json": 52944,
	"./houseFlow/presentation/locales/es-ES.json": 14585,
	"./houseFlow/presentation/locales/pt-BR.json": 7478,
	"./houseFlow/presentation/locales/pt-PT.json": 25242,
	"./invoice/presentation/locales/en-US.json": 63337,
	"./invoice/presentation/locales/es-ES.json": 8499,
	"./invoice/presentation/locales/pt-BR.json": 28719,
	"./invoice/presentation/locales/pt-PT.json": 50355,
	"./invoices/presentation/locales/en-US.json": 5889,
	"./invoices/presentation/locales/es-ES.json": 50006,
	"./invoices/presentation/locales/pt-BR.json": 63713,
	"./invoices/presentation/locales/pt-PT.json": 39147,
	"./kds/presentation/locales/en-US.json": 81718,
	"./kds/presentation/locales/es-ES.json": 44192,
	"./kds/presentation/locales/pt-BR.json": 74161,
	"./kds/presentation/locales/pt-PT.json": 44102,
	"./linkCards/presentation/locales/en-US.json": 55424,
	"./linkCards/presentation/locales/es-ES.json": 28002,
	"./linkCards/presentation/locales/pt-BR.json": 61833,
	"./linkCards/presentation/locales/pt-PT.json": 62647,
	"./mainDashboard/presentation/locales/en-US.json": 6426,
	"./mainDashboard/presentation/locales/es-ES.json": 26020,
	"./mainDashboard/presentation/locales/pt-BR.json": 88192,
	"./mainDashboard/presentation/locales/pt-PT.json": 85088,
	"./managementReport/presentation/locales/en-US.json": 36604,
	"./managementReport/presentation/locales/es-ES.json": 17052,
	"./managementReport/presentation/locales/pt-BR.json": 47226,
	"./managementReport/presentation/locales/pt-PT.json": 24481,
	"./manualAccounts/presentation/locales/en-US.json": 45107,
	"./manualAccounts/presentation/locales/es-ES.json": 52514,
	"./manualAccounts/presentation/locales/pt-BR.json": 24774,
	"./manualAccounts/presentation/locales/pt-PT.json": 19672,
	"./meepFee/presentation/locales/en-US.json": 36591,
	"./meepFee/presentation/locales/es-ES.json": 27403,
	"./meepFee/presentation/locales/pt-BR.json": 26876,
	"./meepFee/presentation/locales/pt-PT.json": 94208,
	"./onboarding/presentation/locales/en-US.json": 65001,
	"./onboarding/presentation/locales/es-ES.json": 49590,
	"./onboarding/presentation/locales/pt-BR.json": 84128,
	"./onboarding/presentation/locales/pt-PT.json": 19854,
	"./operators/presentation/locales/en-US.json": 30413,
	"./operators/presentation/locales/es-ES.json": 35943,
	"./operators/presentation/locales/pt-BR.json": 98404,
	"./operators/presentation/locales/pt-PT.json": 8334,
	"./order/presentation/locales/en-US.json": 75513,
	"./order/presentation/locales/es-ES.json": 86436,
	"./order/presentation/locales/pt-BR.json": 57026,
	"./order/presentation/locales/pt-PT.json": 88443,
	"./paymentLinkReport/presentation/locales/en-US.json": 44340,
	"./paymentLinkReport/presentation/locales/es-ES.json": 27585,
	"./paymentLinkReport/presentation/locales/pt-BR.json": 65227,
	"./paymentLinkReport/presentation/locales/pt-PT.json": 86493,
	"./paymentMethods/presentation/locales/en-US.json": 56363,
	"./paymentMethods/presentation/locales/es-ES.json": 40059,
	"./paymentMethods/presentation/locales/pt-BR.json": 28351,
	"./paymentMethods/presentation/locales/pt-PT.json": 88517,
	"./permutation/presentation/locales/en-US.json": 8403,
	"./permutation/presentation/locales/es-ES.json": 22163,
	"./permutation/presentation/locales/pt-BR.json": 1941,
	"./permutation/presentation/locales/pt-PT.json": 26058,
	"./plans/presentation/locales/en-US.json": 59614,
	"./plans/presentation/locales/es-ES.json": 91146,
	"./plans/presentation/locales/pt-BR.json": 33904,
	"./plans/presentation/locales/pt-PT.json": 51016,
	"./printers/presentation/locales/en-US.json": 93067,
	"./printers/presentation/locales/es-ES.json": 80402,
	"./printers/presentation/locales/pt-BR.json": 57112,
	"./printers/presentation/locales/pt-PT.json": 8060,
	"./productSuggestionConfig/presentation/locales/en-US.json": 30717,
	"./productSuggestionConfig/presentation/locales/es-ES.json": 51638,
	"./productSuggestionConfig/presentation/locales/pt-BR.json": 55185,
	"./productSuggestionConfig/presentation/locales/pt-PT.json": 280,
	"./products/presentation/locales/en-US.json": 34721,
	"./products/presentation/locales/es-ES.json": 40676,
	"./products/presentation/locales/pt-BR.json": 52606,
	"./products/presentation/locales/pt-PT.json": 85509,
	"./receivablesReport/presentation/locales/en-US.json": 91005,
	"./receivablesReport/presentation/locales/es-ES.json": 95625,
	"./receivablesReport/presentation/locales/pt-BR.json": 2153,
	"./receivablesReport/presentation/locales/pt-PT.json": 11136,
	"./reports/cashlessTags/presentation/locales/en-US.json": 90247,
	"./reports/cashlessTags/presentation/locales/es-ES.json": 25962,
	"./reports/cashlessTags/presentation/locales/pt-BR.json": 78061,
	"./reports/cashlessTags/presentation/locales/pt-PT.json": 4000,
	"./reports/refundRequests/presentation/locales/en-US.json": 45971,
	"./reports/refundRequests/presentation/locales/es-ES.json": 13626,
	"./reports/refundRequests/presentation/locales/pt-BR.json": 50407,
	"./reports/refundRequests/presentation/locales/pt-PT.json": 93564,
	"./saas/presentation/locales/en-US.json": 25531,
	"./saas/presentation/locales/es-ES.json": 49497,
	"./saas/presentation/locales/pt-BR.json": 34526,
	"./saas/presentation/locales/pt-PT.json": 85780,
	"./saasHome/presentation/locales/en-US.json": 62285,
	"./saasHome/presentation/locales/es-ES.json": 85439,
	"./saasHome/presentation/locales/pt-BR.json": 14609,
	"./saasHome/presentation/locales/pt-PT.json": 81731,
	"./saasPayment/presentation/locales/en-US.json": 32738,
	"./saasPayment/presentation/locales/es-ES.json": 95176,
	"./saasPayment/presentation/locales/pt-BR.json": 21502,
	"./saasPayment/presentation/locales/pt-PT.json": 88949,
	"./saleForDevice/presentation/locales/en-US.json": 59494,
	"./saleForDevice/presentation/locales/es-ES.json": 5293,
	"./saleForDevice/presentation/locales/pt-BR.json": 96281,
	"./saleForDevice/presentation/locales/pt-PT.json": 24375,
	"./saleForOperator/presentation/locales/en-US.json": 62550,
	"./saleForOperator/presentation/locales/es-ES.json": 63799,
	"./saleForOperator/presentation/locales/pt-BR.json": 7479,
	"./saleForOperator/presentation/locales/pt-PT.json": 78217,
	"./saleForProduct/presentation/locales/en-US.json": 26596,
	"./saleForProduct/presentation/locales/es-ES.json": 11245,
	"./saleForProduct/presentation/locales/pt-BR.json": 15273,
	"./saleForProduct/presentation/locales/pt-PT.json": 35456,
	"./salesPos/presentation/locales/en-US.json": 93463,
	"./salesPos/presentation/locales/es-ES.json": 35560,
	"./salesPos/presentation/locales/pt-BR.json": 61635,
	"./salesPos/presentation/locales/pt-PT.json": 77870,
	"./salesReportByCardBrand/presentation/locales/en-US.json": 64553,
	"./salesReportByCardBrand/presentation/locales/es-ES.json": 26493,
	"./salesReportByCardBrand/presentation/locales/pt-BR.json": 69062,
	"./salesReportByCardBrand/presentation/locales/pt-PT.json": 91974,
	"./salesReportByProductAndPaymentMethod/presentation/locales/en-US.json": 47760,
	"./salesReportByProductAndPaymentMethod/presentation/locales/es-ES.json": 55138,
	"./salesReportByProductAndPaymentMethod/presentation/locales/pt-BR.json": 79086,
	"./salesReportByProductAndPaymentMethod/presentation/locales/pt-PT.json": 56803,
	"./salesReportByProduction/presentation/locales/en-US.json": 93936,
	"./salesReportByProduction/presentation/locales/es-ES.json": 41253,
	"./salesReportByProduction/presentation/locales/pt-BR.json": 2520,
	"./salesReportByProduction/presentation/locales/pt-PT.json": 55857,
	"./salesReportBySaleType/presentation/locales/en-US.json": 36028,
	"./salesReportBySaleType/presentation/locales/es-ES.json": 69256,
	"./salesReportBySaleType/presentation/locales/pt-BR.json": 87352,
	"./salesReportBySaleType/presentation/locales/pt-PT.json": 46846,
	"./splitReport/presentation/locales/en-US.json": 18080,
	"./splitReport/presentation/locales/es-ES.json": 14701,
	"./splitReport/presentation/locales/pt-BR.json": 95062,
	"./splitReport/presentation/locales/pt-PT.json": 53764,
	"./table/presentation/locales/en-US.json": 51153,
	"./table/presentation/locales/es-ES.json": 62838,
	"./table/presentation/locales/pt-BR.json": 43142,
	"./table/presentation/locales/pt-PT.json": 61396,
	"./ticketsReport/presentation/locales/en-US.json": 97311,
	"./ticketsReport/presentation/locales/es-ES.json": 80213,
	"./ticketsReport/presentation/locales/pt-BR.json": 95338,
	"./ticketsReport/presentation/locales/pt-PT.json": 16951,
	"./tools/presentation/locales/en-US.json": 58921,
	"./tools/presentation/locales/es-ES.json": 52808,
	"./tools/presentation/locales/pt-BR.json": 96723,
	"./tools/presentation/locales/pt-PT.json": 39004,
	"./totemListConfig/presentation/locales/en-US.json": 61785,
	"./totemListConfig/presentation/locales/es-ES.json": 21649,
	"./totemListConfig/presentation/locales/pt-BR.json": 45271,
	"./totemListConfig/presentation/locales/pt-PT.json": 20070,
	"./transactionReport/presentation/locales/en-US.json": 39346,
	"./transactionReport/presentation/locales/es-ES.json": 84111,
	"./transactionReport/presentation/locales/pt-BR.json": 92558,
	"./transactionReport/presentation/locales/pt-PT.json": 50765,
	"./transactionReversal/presentation/locales/en-US.json": 9191,
	"./transactionReversal/presentation/locales/es-ES.json": 93263,
	"./transactionReversal/presentation/locales/pt-BR.json": 64605,
	"./transactionReversal/presentation/locales/pt-PT.json": 22611,
	"./transactionRouting/presentation/locales/en-US.json": 11183,
	"./transactionRouting/presentation/locales/es-ES.json": 5298,
	"./transactionRouting/presentation/locales/pt-BR.json": 53745,
	"./transactionRouting/presentation/locales/pt-PT.json": 16917,
	"modules/RefundCashlessReport/presentation/locales/en-US.json": 89167,
	"modules/RefundCashlessReport/presentation/locales/es-ES.json": 66163,
	"modules/RefundCashlessReport/presentation/locales/pt-BR.json": 85908,
	"modules/RefundCashlessReport/presentation/locales/pt-PT.json": 11206,
	"modules/SaleForDayPage/presentation/locales/en-US.json": 55583,
	"modules/SaleForDayPage/presentation/locales/es-ES.json": 14495,
	"modules/SaleForDayPage/presentation/locales/pt-BR.json": 91769,
	"modules/SaleForDayPage/presentation/locales/pt-PT.json": 7965,
	"modules/Terminal/presentation/locales/en-US.json": 10169,
	"modules/Terminal/presentation/locales/es-ES.json": 52071,
	"modules/Terminal/presentation/locales/pt-BR.json": 92968,
	"modules/Terminal/presentation/locales/pt-PT.json": 91824,
	"modules/addStore/presentation/locales/en-US.json": 58100,
	"modules/addStore/presentation/locales/es-ES.json": 42441,
	"modules/addStore/presentation/locales/pt-BR.json": 44584,
	"modules/addStore/presentation/locales/pt-PT.json": 75430,
	"modules/aiBot/presentation/locales/en-US.json": 57160,
	"modules/aiBot/presentation/locales/es-ES.json": 81327,
	"modules/aiBot/presentation/locales/pt-BR.json": 577,
	"modules/aiBot/presentation/locales/pt-PT.json": 72093,
	"modules/bankAccounts/presentation/locales/en-US.json": 69962,
	"modules/bankAccounts/presentation/locales/es-ES.json": 85462,
	"modules/bankAccounts/presentation/locales/pt-BR.json": 29207,
	"modules/bankAccounts/presentation/locales/pt-PT.json": 88916,
	"modules/cardBalanceReportApi/presentation/locales/en-US.json": 40864,
	"modules/cardBalanceReportApi/presentation/locales/es-ES.json": 57032,
	"modules/cardBalanceReportApi/presentation/locales/pt-BR.json": 82552,
	"modules/cardBalanceReportApi/presentation/locales/pt-PT.json": 32450,
	"modules/cardGroups/presentation/locales/en-US.json": 81135,
	"modules/cardGroups/presentation/locales/es-ES.json": 90585,
	"modules/cardGroups/presentation/locales/pt-BR.json": 77169,
	"modules/cardGroups/presentation/locales/pt-PT.json": 95638,
	"modules/cargos/presentation/locales/en-US.json": 9712,
	"modules/cargos/presentation/locales/es-ES.json": 81275,
	"modules/cargos/presentation/locales/pt-BR.json": 87025,
	"modules/cargos/presentation/locales/pt-PT.json": 33024,
	"modules/cashCancellation/presentation/locales/en-US.json": 31971,
	"modules/cashCancellation/presentation/locales/es-ES.json": 72008,
	"modules/cashCancellation/presentation/locales/pt-BR.json": 32388,
	"modules/cashCancellation/presentation/locales/pt-PT.json": 58556,
	"modules/cashClosing/presentation/locales/en-US.json": 54549,
	"modules/cashClosing/presentation/locales/es-ES.json": 85862,
	"modules/cashClosing/presentation/locales/pt-BR.json": 24744,
	"modules/cashClosing/presentation/locales/pt-PT.json": 24548,
	"modules/cashWithdrawal/presentation/locales/en-US.json": 43102,
	"modules/cashWithdrawal/presentation/locales/es-ES.json": 10194,
	"modules/cashWithdrawal/presentation/locales/pt-BR.json": 25744,
	"modules/cashWithdrawal/presentation/locales/pt-PT.json": 97019,
	"modules/cashWithdrawalAndSupply/presentation/locales/en-US.json": 38320,
	"modules/cashWithdrawalAndSupply/presentation/locales/es-ES.json": 2475,
	"modules/cashWithdrawalAndSupply/presentation/locales/pt-BR.json": 1622,
	"modules/cashWithdrawalAndSupply/presentation/locales/pt-PT.json": 85786,
	"modules/catalog/presentation/locales/en-US.json": 57793,
	"modules/catalog/presentation/locales/es-ES.json": 80416,
	"modules/catalog/presentation/locales/pt-BR.json": 76656,
	"modules/catalog/presentation/locales/pt-PT.json": 37689,
	"modules/classification/presentation/locales/en-US.json": 71509,
	"modules/classification/presentation/locales/es-ES.json": 85240,
	"modules/classification/presentation/locales/pt-BR.json": 86047,
	"modules/classification/presentation/locales/pt-PT.json": 91881,
	"modules/colaboradores/presentation/locales/en-US.json": 34336,
	"modules/colaboradores/presentation/locales/es-ES.json": 81921,
	"modules/colaboradores/presentation/locales/pt-BR.json": 56973,
	"modules/colaboradores/presentation/locales/pt-PT.json": 35790,
	"modules/commandMap/presentation/locales/en-US.json": 91128,
	"modules/commandMap/presentation/locales/es-ES.json": 22801,
	"modules/commandMap/presentation/locales/pt-BR.json": 24445,
	"modules/commandMap/presentation/locales/pt-PT.json": 65220,
	"modules/config/deviceConfig/presentation/locales/en-US.json": 88594,
	"modules/config/deviceConfig/presentation/locales/es-ES.json": 97065,
	"modules/config/deviceConfig/presentation/locales/pt-BR.json": 80985,
	"modules/config/deviceConfig/presentation/locales/pt-PT.json": 6303,
	"modules/config/integrationsConfig/presentation/locales/en-US.json": 23736,
	"modules/config/integrationsConfig/presentation/locales/es-ES.json": 93483,
	"modules/config/integrationsConfig/presentation/locales/pt-BR.json": 26868,
	"modules/config/integrationsConfig/presentation/locales/pt-PT.json": 66523,
	"modules/config/smartPrinterConfig/presentation/locales/en-US.json": 22570,
	"modules/config/smartPrinterConfig/presentation/locales/es-ES.json": 78335,
	"modules/config/smartPrinterConfig/presentation/locales/pt-BR.json": 93574,
	"modules/config/smartPrinterConfig/presentation/locales/pt-PT.json": 95063,
	"modules/contaDigital/presentation/locales/en-US.json": 40173,
	"modules/contaDigital/presentation/locales/es-ES.json": 93454,
	"modules/contaDigital/presentation/locales/pt-BR.json": 58248,
	"modules/contaDigital/presentation/locales/pt-PT.json": 80848,
	"modules/createOrders/presentation/locales/en-US.json": 45419,
	"modules/createOrders/presentation/locales/es-ES.json": 91612,
	"modules/createOrders/presentation/locales/pt-BR.json": 24056,
	"modules/createOrders/presentation/locales/pt-PT.json": 57901,
	"modules/crm/presentation/locales/en-US.json": 68907,
	"modules/crm/presentation/locales/es-ES.json": 47888,
	"modules/crm/presentation/locales/pt-BR.json": 47140,
	"modules/crm/presentation/locales/pt-PT.json": 2679,
	"modules/customerCategories/presentation/locales/en-US.json": 88829,
	"modules/customerCategories/presentation/locales/es-ES.json": 47653,
	"modules/customerCategories/presentation/locales/pt-BR.json": 35742,
	"modules/customerCategories/presentation/locales/pt-PT.json": 43918,
	"modules/customerInformation/presentation/locales/en-US.json": 79260,
	"modules/customerInformation/presentation/locales/es-ES.json": 32045,
	"modules/customerInformation/presentation/locales/pt-BR.json": 77741,
	"modules/customerInformation/presentation/locales/pt-PT.json": 7393,
	"modules/customerRegistration/presentation/locales/en-US.json": 25343,
	"modules/customerRegistration/presentation/locales/es-ES.json": 37697,
	"modules/customerRegistration/presentation/locales/pt-BR.json": 88657,
	"modules/customerRegistration/presentation/locales/pt-PT.json": 78367,
	"modules/customersDashboard/presentation/locales/en-US.json": 77074,
	"modules/customersDashboard/presentation/locales/es-ES.json": 99953,
	"modules/customersDashboard/presentation/locales/pt-BR.json": 43271,
	"modules/customersDashboard/presentation/locales/pt-PT.json": 58103,
	"modules/detailedSale/presentation/locales/en-US.json": 73576,
	"modules/detailedSale/presentation/locales/es-ES.json": 2499,
	"modules/detailedSale/presentation/locales/pt-BR.json": 49643,
	"modules/detailedSale/presentation/locales/pt-PT.json": 20960,
	"modules/digitalMenu/presentation/locales/en-US.json": 70459,
	"modules/digitalMenu/presentation/locales/es-ES.json": 80120,
	"modules/digitalMenu/presentation/locales/pt-BR.json": 2147,
	"modules/digitalMenu/presentation/locales/pt-PT.json": 32351,
	"modules/equipamento/presentation/locales/en-US.json": 81001,
	"modules/equipamento/presentation/locales/es-ES.json": 8150,
	"modules/equipamento/presentation/locales/pt-BR.json": 40025,
	"modules/equipamento/presentation/locales/pt-PT.json": 16954,
	"modules/events/presentation/locales/en-US.json": 98160,
	"modules/events/presentation/locales/es-ES.json": 40718,
	"modules/events/presentation/locales/pt-BR.json": 77177,
	"modules/events/presentation/locales/pt-PT.json": 31865,
	"modules/financeiro/presentation/locales/en-US.json": 6166,
	"modules/financeiro/presentation/locales/es-ES.json": 15006,
	"modules/financeiro/presentation/locales/pt-BR.json": 79364,
	"modules/financeiro/presentation/locales/pt-PT.json": 14758,
	"modules/financialCashWithdrawal/presentation/locales/en-US.json": 7700,
	"modules/financialCashWithdrawal/presentation/locales/es-ES.json": 23672,
	"modules/financialCashWithdrawal/presentation/locales/pt-BR.json": 46717,
	"modules/financialCashWithdrawal/presentation/locales/pt-PT.json": 35954,
	"modules/financialManagementRecord/presentation/locales/en-US.json": 14683,
	"modules/financialManagementRecord/presentation/locales/es-ES.json": 46603,
	"modules/financialManagementRecord/presentation/locales/pt-BR.json": 70707,
	"modules/financialManagementRecord/presentation/locales/pt-PT.json": 5077,
	"modules/generalDashboard/presentation/locales/en-US.json": 5494,
	"modules/generalDashboard/presentation/locales/es-ES.json": 67510,
	"modules/generalDashboard/presentation/locales/pt-BR.json": 75990,
	"modules/generalDashboard/presentation/locales/pt-PT.json": 37671,
	"modules/gestaoVendas/presentation/locales/en-US.json": 84405,
	"modules/gestaoVendas/presentation/locales/es-ES.json": 94520,
	"modules/gestaoVendas/presentation/locales/pt-BR.json": 30554,
	"modules/gestaoVendas/presentation/locales/pt-PT.json": 7043,
	"modules/groupedSplit/presentation/locales/en-US.json": 75030,
	"modules/groupedSplit/presentation/locales/es-ES.json": 90393,
	"modules/groupedSplit/presentation/locales/pt-BR.json": 70388,
	"modules/groupedSplit/presentation/locales/pt-PT.json": 40722,
	"modules/houseFlow/presentation/locales/en-US.json": 52944,
	"modules/houseFlow/presentation/locales/es-ES.json": 14585,
	"modules/houseFlow/presentation/locales/pt-BR.json": 7478,
	"modules/houseFlow/presentation/locales/pt-PT.json": 25242,
	"modules/invoice/presentation/locales/en-US.json": 63337,
	"modules/invoice/presentation/locales/es-ES.json": 8499,
	"modules/invoice/presentation/locales/pt-BR.json": 28719,
	"modules/invoice/presentation/locales/pt-PT.json": 50355,
	"modules/invoices/presentation/locales/en-US.json": 5889,
	"modules/invoices/presentation/locales/es-ES.json": 50006,
	"modules/invoices/presentation/locales/pt-BR.json": 63713,
	"modules/invoices/presentation/locales/pt-PT.json": 39147,
	"modules/kds/presentation/locales/en-US.json": 81718,
	"modules/kds/presentation/locales/es-ES.json": 44192,
	"modules/kds/presentation/locales/pt-BR.json": 74161,
	"modules/kds/presentation/locales/pt-PT.json": 44102,
	"modules/linkCards/presentation/locales/en-US.json": 55424,
	"modules/linkCards/presentation/locales/es-ES.json": 28002,
	"modules/linkCards/presentation/locales/pt-BR.json": 61833,
	"modules/linkCards/presentation/locales/pt-PT.json": 62647,
	"modules/mainDashboard/presentation/locales/en-US.json": 6426,
	"modules/mainDashboard/presentation/locales/es-ES.json": 26020,
	"modules/mainDashboard/presentation/locales/pt-BR.json": 88192,
	"modules/mainDashboard/presentation/locales/pt-PT.json": 85088,
	"modules/managementReport/presentation/locales/en-US.json": 36604,
	"modules/managementReport/presentation/locales/es-ES.json": 17052,
	"modules/managementReport/presentation/locales/pt-BR.json": 47226,
	"modules/managementReport/presentation/locales/pt-PT.json": 24481,
	"modules/manualAccounts/presentation/locales/en-US.json": 45107,
	"modules/manualAccounts/presentation/locales/es-ES.json": 52514,
	"modules/manualAccounts/presentation/locales/pt-BR.json": 24774,
	"modules/manualAccounts/presentation/locales/pt-PT.json": 19672,
	"modules/meepFee/presentation/locales/en-US.json": 36591,
	"modules/meepFee/presentation/locales/es-ES.json": 27403,
	"modules/meepFee/presentation/locales/pt-BR.json": 26876,
	"modules/meepFee/presentation/locales/pt-PT.json": 94208,
	"modules/onboarding/presentation/locales/en-US.json": 65001,
	"modules/onboarding/presentation/locales/es-ES.json": 49590,
	"modules/onboarding/presentation/locales/pt-BR.json": 84128,
	"modules/onboarding/presentation/locales/pt-PT.json": 19854,
	"modules/operators/presentation/locales/en-US.json": 30413,
	"modules/operators/presentation/locales/es-ES.json": 35943,
	"modules/operators/presentation/locales/pt-BR.json": 98404,
	"modules/operators/presentation/locales/pt-PT.json": 8334,
	"modules/order/presentation/locales/en-US.json": 75513,
	"modules/order/presentation/locales/es-ES.json": 86436,
	"modules/order/presentation/locales/pt-BR.json": 57026,
	"modules/order/presentation/locales/pt-PT.json": 88443,
	"modules/paymentLinkReport/presentation/locales/en-US.json": 44340,
	"modules/paymentLinkReport/presentation/locales/es-ES.json": 27585,
	"modules/paymentLinkReport/presentation/locales/pt-BR.json": 65227,
	"modules/paymentLinkReport/presentation/locales/pt-PT.json": 86493,
	"modules/paymentMethods/presentation/locales/en-US.json": 56363,
	"modules/paymentMethods/presentation/locales/es-ES.json": 40059,
	"modules/paymentMethods/presentation/locales/pt-BR.json": 28351,
	"modules/paymentMethods/presentation/locales/pt-PT.json": 88517,
	"modules/permutation/presentation/locales/en-US.json": 8403,
	"modules/permutation/presentation/locales/es-ES.json": 22163,
	"modules/permutation/presentation/locales/pt-BR.json": 1941,
	"modules/permutation/presentation/locales/pt-PT.json": 26058,
	"modules/plans/presentation/locales/en-US.json": 59614,
	"modules/plans/presentation/locales/es-ES.json": 91146,
	"modules/plans/presentation/locales/pt-BR.json": 33904,
	"modules/plans/presentation/locales/pt-PT.json": 51016,
	"modules/printers/presentation/locales/en-US.json": 93067,
	"modules/printers/presentation/locales/es-ES.json": 80402,
	"modules/printers/presentation/locales/pt-BR.json": 57112,
	"modules/printers/presentation/locales/pt-PT.json": 8060,
	"modules/productSuggestionConfig/presentation/locales/en-US.json": 30717,
	"modules/productSuggestionConfig/presentation/locales/es-ES.json": 51638,
	"modules/productSuggestionConfig/presentation/locales/pt-BR.json": 55185,
	"modules/productSuggestionConfig/presentation/locales/pt-PT.json": 280,
	"modules/products/presentation/locales/en-US.json": 34721,
	"modules/products/presentation/locales/es-ES.json": 40676,
	"modules/products/presentation/locales/pt-BR.json": 52606,
	"modules/products/presentation/locales/pt-PT.json": 85509,
	"modules/receivablesReport/presentation/locales/en-US.json": 91005,
	"modules/receivablesReport/presentation/locales/es-ES.json": 95625,
	"modules/receivablesReport/presentation/locales/pt-BR.json": 2153,
	"modules/receivablesReport/presentation/locales/pt-PT.json": 11136,
	"modules/reports/cashlessTags/presentation/locales/en-US.json": 90247,
	"modules/reports/cashlessTags/presentation/locales/es-ES.json": 25962,
	"modules/reports/cashlessTags/presentation/locales/pt-BR.json": 78061,
	"modules/reports/cashlessTags/presentation/locales/pt-PT.json": 4000,
	"modules/reports/refundRequests/presentation/locales/en-US.json": 45971,
	"modules/reports/refundRequests/presentation/locales/es-ES.json": 13626,
	"modules/reports/refundRequests/presentation/locales/pt-BR.json": 50407,
	"modules/reports/refundRequests/presentation/locales/pt-PT.json": 93564,
	"modules/saas/presentation/locales/en-US.json": 25531,
	"modules/saas/presentation/locales/es-ES.json": 49497,
	"modules/saas/presentation/locales/pt-BR.json": 34526,
	"modules/saas/presentation/locales/pt-PT.json": 85780,
	"modules/saasHome/presentation/locales/en-US.json": 62285,
	"modules/saasHome/presentation/locales/es-ES.json": 85439,
	"modules/saasHome/presentation/locales/pt-BR.json": 14609,
	"modules/saasHome/presentation/locales/pt-PT.json": 81731,
	"modules/saasPayment/presentation/locales/en-US.json": 32738,
	"modules/saasPayment/presentation/locales/es-ES.json": 95176,
	"modules/saasPayment/presentation/locales/pt-BR.json": 21502,
	"modules/saasPayment/presentation/locales/pt-PT.json": 88949,
	"modules/saleForDevice/presentation/locales/en-US.json": 59494,
	"modules/saleForDevice/presentation/locales/es-ES.json": 5293,
	"modules/saleForDevice/presentation/locales/pt-BR.json": 96281,
	"modules/saleForDevice/presentation/locales/pt-PT.json": 24375,
	"modules/saleForOperator/presentation/locales/en-US.json": 62550,
	"modules/saleForOperator/presentation/locales/es-ES.json": 63799,
	"modules/saleForOperator/presentation/locales/pt-BR.json": 7479,
	"modules/saleForOperator/presentation/locales/pt-PT.json": 78217,
	"modules/saleForProduct/presentation/locales/en-US.json": 26596,
	"modules/saleForProduct/presentation/locales/es-ES.json": 11245,
	"modules/saleForProduct/presentation/locales/pt-BR.json": 15273,
	"modules/saleForProduct/presentation/locales/pt-PT.json": 35456,
	"modules/salesPos/presentation/locales/en-US.json": 93463,
	"modules/salesPos/presentation/locales/es-ES.json": 35560,
	"modules/salesPos/presentation/locales/pt-BR.json": 61635,
	"modules/salesPos/presentation/locales/pt-PT.json": 77870,
	"modules/salesReportByCardBrand/presentation/locales/en-US.json": 64553,
	"modules/salesReportByCardBrand/presentation/locales/es-ES.json": 26493,
	"modules/salesReportByCardBrand/presentation/locales/pt-BR.json": 69062,
	"modules/salesReportByCardBrand/presentation/locales/pt-PT.json": 91974,
	"modules/salesReportByProductAndPaymentMethod/presentation/locales/en-US.json": 47760,
	"modules/salesReportByProductAndPaymentMethod/presentation/locales/es-ES.json": 55138,
	"modules/salesReportByProductAndPaymentMethod/presentation/locales/pt-BR.json": 79086,
	"modules/salesReportByProductAndPaymentMethod/presentation/locales/pt-PT.json": 56803,
	"modules/salesReportByProduction/presentation/locales/en-US.json": 93936,
	"modules/salesReportByProduction/presentation/locales/es-ES.json": 41253,
	"modules/salesReportByProduction/presentation/locales/pt-BR.json": 2520,
	"modules/salesReportByProduction/presentation/locales/pt-PT.json": 55857,
	"modules/salesReportBySaleType/presentation/locales/en-US.json": 36028,
	"modules/salesReportBySaleType/presentation/locales/es-ES.json": 69256,
	"modules/salesReportBySaleType/presentation/locales/pt-BR.json": 87352,
	"modules/salesReportBySaleType/presentation/locales/pt-PT.json": 46846,
	"modules/splitReport/presentation/locales/en-US.json": 18080,
	"modules/splitReport/presentation/locales/es-ES.json": 14701,
	"modules/splitReport/presentation/locales/pt-BR.json": 95062,
	"modules/splitReport/presentation/locales/pt-PT.json": 53764,
	"modules/table/presentation/locales/en-US.json": 51153,
	"modules/table/presentation/locales/es-ES.json": 62838,
	"modules/table/presentation/locales/pt-BR.json": 43142,
	"modules/table/presentation/locales/pt-PT.json": 61396,
	"modules/ticketsReport/presentation/locales/en-US.json": 97311,
	"modules/ticketsReport/presentation/locales/es-ES.json": 80213,
	"modules/ticketsReport/presentation/locales/pt-BR.json": 95338,
	"modules/ticketsReport/presentation/locales/pt-PT.json": 16951,
	"modules/tools/presentation/locales/en-US.json": 58921,
	"modules/tools/presentation/locales/es-ES.json": 52808,
	"modules/tools/presentation/locales/pt-BR.json": 96723,
	"modules/tools/presentation/locales/pt-PT.json": 39004,
	"modules/totemListConfig/presentation/locales/en-US.json": 61785,
	"modules/totemListConfig/presentation/locales/es-ES.json": 21649,
	"modules/totemListConfig/presentation/locales/pt-BR.json": 45271,
	"modules/totemListConfig/presentation/locales/pt-PT.json": 20070,
	"modules/transactionReport/presentation/locales/en-US.json": 39346,
	"modules/transactionReport/presentation/locales/es-ES.json": 84111,
	"modules/transactionReport/presentation/locales/pt-BR.json": 92558,
	"modules/transactionReport/presentation/locales/pt-PT.json": 50765,
	"modules/transactionReversal/presentation/locales/en-US.json": 9191,
	"modules/transactionReversal/presentation/locales/es-ES.json": 93263,
	"modules/transactionReversal/presentation/locales/pt-BR.json": 64605,
	"modules/transactionReversal/presentation/locales/pt-PT.json": 22611,
	"modules/transactionRouting/presentation/locales/en-US.json": 11183,
	"modules/transactionRouting/presentation/locales/es-ES.json": 5298,
	"modules/transactionRouting/presentation/locales/pt-BR.json": 53745,
	"modules/transactionRouting/presentation/locales/pt-PT.json": 16917
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31397;